
// var userFeed = new Instafeed({
//   get: 'user',
//   target: 'instafeed',
//   limit: 9,
//   userId: '8736487922',
//   accessToken: '8736487922.53edfe0.dcd6d317010a42ee990ce54e32341aba',
//   // clientId: '53edfe0053aa4e41b79244e7c0109bad',
//   template: '<a href="{{link}}" class="p-top-instagram__item" target="_blank"><img src="{{image}}"></a>'
// });
// userFeed.run();


  $(window).on('load', function() {
    $('.js-top-slide').css('visibility', 'visible').slick({
      autoplay: true,
      infinite: true,
      dots: true,
      dotsClass: 'p-top-slide__dots',
      prevArrow: $('.p-top-slide__prev'),
      nextArrow: $('.p-top-slide__next'),
    });
    $('.p-top-slide__prev, .p-top-slide__next').css('visibility', 'visible');
  });

  // インスタGraph API 取得
  $.ajax({
    type: 'GET',
    url: 'https://graph.facebook.com/v13.0/17841408877672060?fields=name%2Cmedia.limit(9)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cthumbnail_url%2Cmedia_type%2Cusername%7D&access_token=EAAUaWCZCpXUcBAERaH4RoOdYkN00ZCr5MCVYq4bEkK8pjAVVKbF6liRIljkGtLJ7WSMhmMcWgCHRM2SBXfGN7V2jp2NmTVMDXDZBNwxgdrgCdXs5KPBMvB2W762ORpLKJh6lEDYZA78UAoZAuw67Lk0R2ovpudtIzZCw93eHqsAiZCs878LZCDQ5',
    dataType: 'json',
    success: function (json) {
      var ig = json.media.data;
      var html = '';
      for (var i = 0; i < ig.length; i++) {
        var media_type = ig[i].media_type;
        if (ig[i].media_type == 'IMAGE' || ig[i].media_type == 'CAROUSEL_ALBUM') {
          html += '<li class="p-top-instagram__item"><a href="' + ig[i].permalink + '" target="_blank"><img src="' + ig[i].media_url + '"></a></li>';
        } else if (media_type == 'VIDEO') {
          html += '<li class="p-top-instagram__item"><a href="' + ig[i].permalink + '" target="_blank"><img src="' + ig[i].thumbnail_url + '"></a></li>';
          var media_type = '';
        }
      }
      $("#instafeed").append(html);
    }
  });
